import type { IconProps } from './types';

function ImageIcon(props: IconProps) {
  const { size = 32, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 8V15.1111H26V6H16.8889V8H24ZM24 24V16.8889H26V26H16.8889V24H24ZM6 16.8889V26H15.1111V24H8V16.8889H6ZM6 15.1111H8V8H15.1111V6H6V15.1111ZM17.3333 13.3333C17.3333 12.106 18.3283 11.1111 19.5556 11.1111C20.7828 11.1111 21.7778 12.106 21.7778 13.3333C21.7778 14.5606 20.7828 15.5556 19.5556 15.5556C18.3283 15.5556 17.3333 14.5606 17.3333 13.3333ZM11.5556 14.7429L16.8889 20.0763L19.5556 17.4096L22.2222 20.0763V22H10V16.2985L11.5556 14.7429Z"
        fill={color}
      />
    </svg>
  );
}

export { ImageIcon };
